module.exports = __webpack_public_path__ + "static/media/whitesquarelogo.1c8525a6.png";